module.exports = __webpack_public_path__ + "static/media/manovr-6.1edd5646.jpg";